exports.inFo = {
  dailyOutput: "272940.22", //日产出(mLAMB)
  totalCapacity: "545.43", //全网声明总容量（PB）
  totalPower: "5.47", //当前全网总算力（PB）
  dailyConvert: "27028.80", //日产出 (LAMB)
  reserve: "65798923.93", //当前总准备金（mLAMB）
  reserveIncome: "1.16", //当前准备金收益（mLAMB/天）
  reserveConvert: "6590091.23", //当前总准备金(LAMB）
  provide: "10000", //提供准备金的预计日收益(mLAMB)
  computingPower: "25.93", //当前算力收益（mLAMB/T）
  totalComputingPower: "1.39", //当前总算力（PB）
  pledge: "31.47" //矿工自行质押的准备金用于挖矿（mLAMB/T）
};
